<template lang="pug">
	
	.background(ref='bg')
		//- img(src="assets/images/noise.png")

	

</template>

<script>
		
	import Vue from 'vue'
	import Component from 'vue-class-component'
	import $ from 'jquery'
	import { TweenMax } from 'gsap'
	import Scroller from '../utils/scroller.js'
	import Ticker from '../utils/ticker.js'
	import * as PIXI from 'pixi.js'

  	@Component({
		name: 'Background',
		components: {  }
	})

	class Background extends Vue {

		mounted () {

			this.init()
		}

		init () {
			
			this.app = new PIXI.Application(window.innerWidth, window.innerHeight,{
				transparent: true,
				antialias: false,
				resolution: 1
			})

			this.then = Date.now()

			this.$refs.bg.appendChild(this.app.view)

			this.bgContainer = new PIXI.Container();
			let bg = new PIXI.Graphics();
			bg.beginFill(0xF5F5F5, 1);
			bg.moveTo(0,0);
			bg.lineTo(0,0);
			bg.lineTo(window.innerWidth,0);
			bg.lineTo(window.innerWidth, window.innerHeight);
			bg.lineTo(0, window.innerHeight);
			bg.endFill();
			this.bgContainer.addChild(bg);


			const shader = `
				uniform float time;
				uniform float fade;
				varying vec2 vTextureCoord;

				float nrand( vec2 n )
				{
					return fract(sin(dot(n.xy, vec2(12.9898, 204.233)))* 43758.5453);
				}

				float n1rand( vec2 n )
				{
					float t = fract( time * 1001.0 );
					float nrnd0 = nrand( n + 0.07 * t );
					return nrnd0 / fade;
				}

				void main()
				{
					float o;

					o = n1rand( vTextureCoord.xy );

					gl_FragColor = vec4(vec3(o), 0.2);
				}

			`

			const uniforms = {
				time: {
					type: 'f',
					value: 0.0
				},
				resolution: {
					type:'v2',
					value:[window.innerWidth,window.innerHeight]
				},
				fade: {
					type: 'f',
					value: 15.0
				}
			}

			this.noiseFilter = new PIXI.Filter('',shader, uniforms)

			this.bgContainer.filters = [this.noiseFilter]
			this.bgContainer.alpha = 1

			this.app.stage.addChild(this.bgContainer)
			this.app.ticker.add(this.update, this)
				
		}

		update () {

			this.now = Date.now()
			this.elapsed = this.now - this.then

			if (this.elapsed > 1000 / 20) {
				this.then = this.now - (this.elapsed % 1000 / 20)
				this.noiseFilter.uniforms.time += .01;
			}

		}

		animateIn () {
			TweenMax.to(this.bgContainer,.5,{alpha:1,ease:Power0.easeNone})
		}

		_resize () {
			if(this.app) {
				this.app.renderer.view.style.width = window.innerWidth + 'px';
    			this.app.renderer.view.style.height = window.innerHeight + 'px';
			}

		}	

	}

	export default Background

</script>


<style lang="stylus">
	
	@import '../theme/utils'
	@import '../theme/variables'
	
	.background
		width 100%
		height 100%
		position absolute
		top 0
		left 0
		pointer-events none
		z-index 100

		img
			height 100%
			width 100%
			opacity .5
			object-fit cover

</style>


// WEBPACK FOOTER //
// background.vue?5b304cb3